import { render, staticRenderFns } from "./alibabaProductInfo.vue?vue&type=template&id=97d62ca4&scoped=true&"
import script from "./alibabaProductInfo.vue?vue&type=script&lang=js&"
export * from "./alibabaProductInfo.vue?vue&type=script&lang=js&"
import style0 from "./alibabaProductInfo.vue?vue&type=style&index=0&id=97d62ca4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d62ca4",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/alibaba/product/alibabaProductInfo.vue
// module id = null
// module chunks = 